import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Pranav M S </span>
            from <span className="purple"> Bangalore, India.</span>
            <br /> I am pursuing my engineering in Computer science at KSIT. 
            <br />
            <br /> I am a Fullstack developer.
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Cooking
            </li>
            <li className="about-activity">
              <ImPointRight /> Making Music
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Give a man a program, frustrate him for a day.<br/>
              Teach a man to program, frustrate him for a lifetime. "{" "}
          </p>
          <footer className="blockquote-footer">Pranav M S</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
